"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var event_bus_1 = require("@cian/event-bus");
require("@cian/event-bus/lib/browser.min.js");
exports.initializeEventBus = function () {
    return event_bus_1.getEventBusIfDefined();
};



//////////////////
// WEBPACK FOOTER
// ./src/browser/initializers/event_bus.ts
// module id = 294
// module chunks = 2